
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.625 3.375a3.375 3.375 0 116.75 0V9a3.375 3.375 0 01-6.75 0V3.375z"}}),_c('path',{attrs:{"clip-rule":"evenodd","d":"M3.938 7.313a.563.563 0 01.562.562V9a4.5 4.5 0 109 0V7.875a.563.563 0 011.125 0V9a5.625 5.625 0 01-5.063 5.597v2.278h3.376a.562.562 0 110 1.125H5.061a.563.563 0 010-1.125h3.375v-2.278A5.625 5.625 0 013.375 9V7.875a.563.563 0 01.563-.563z"}})])
          )
        }
      }
    